var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTime = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m1 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 7.5a.5.5 0 0 1 1 0V13h3.498a.5.5 0 1 1 0 1H11.5a.5.5 0 0 1-.5-.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTime);
export default ForwardRef;